import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import App from '@/App';
import { UpdatePrompt } from '@/components/UpdatePrompt';
import { ApiError } from '@/lib/apiClient';
import { setupI18n } from '@/i18n';
import '@/styles/global.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      // A rede da academia oscila. Uma nova tentativa vale a pena; insistir em
      // erro de autorização ou de regra de negócio, não — o resultado seria o
      // mesmo, com atraso.
      retry: (failureCount, error) => {
        if (error instanceof ApiError && error.status < 500) return false;
        return failureCount < 2;
      },
      refetchOnWindowFocus: true,
    },
  },
});

async function bootstrap() {
  await setupI18n();

  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <QueryClientProvider client={queryClient}>
        {/* Fora do `BrowserRouter`: o aviso de versão nova não depende de rota
            e precisa aparecer inclusive nas telas de entrada, que é onde quem
            volta depois de um deploy costuma chegar. */}
        <UpdatePrompt />
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </QueryClientProvider>
    </StrictMode>,
  );
}

void bootstrap();
